import { render, staticRenderFns } from "./TrackerCard.vue?vue&type=template&id=5353f4eb"
import script from "./TrackerCard.vue?vue&type=script&lang=js"
export * from "./TrackerCard.vue?vue&type=script&lang=js"
import style0 from "./TrackerCard.vue?vue&type=style&index=0&id=5353f4eb&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5353f4eb')) {
      api.createRecord('5353f4eb', component.options)
    } else {
      api.reload('5353f4eb', component.options)
    }
    module.hot.accept("./TrackerCard.vue?vue&type=template&id=5353f4eb", function () {
      api.rerender('5353f4eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/TrackerCard.vue"
export default component.exports